import { render, staticRenderFns } from "./VideoElement.vue?vue&type=template&id=544e48ee&scoped=true&"
import script from "./VideoElement.vue?vue&type=script&lang=ts&"
export * from "./VideoElement.vue?vue&type=script&lang=ts&"
import style0 from "./VideoElement.vue?vue&type=style&index=0&id=544e48ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e48ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRow,VTooltip})
